/*!
 * Built by Revolist
 */
import { R as RevogrHeaderComponent, a as defineCustomElement$1 } from './revogr-header2.js';

const RevogrHeader = RevogrHeaderComponent;
const defineCustomElement = defineCustomElement$1;

export { RevogrHeader, defineCustomElement };
